import React from 'react';
import { Button, Flex, Text, Wrap, WrapItem } from '@chakra-ui/react';

const PRESETS = [
  { id: 'smart', label: 'Smart Cleanup' },
  { id: 'pdf', label: 'PDF Cleanup' },
  { id: 'email', label: 'Email Cleanup' },
  { id: 'plain', label: 'Plain Text' },
  { id: 'oneLine', label: 'One Line' },
  { id: 'preserve', label: 'Preserve Formatting' },
];

const PresetBar = ({ activePresetId, onSelect }) => (
  <Flex direction="column" gap={2}>
    <Text fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase" letterSpacing="0.06em">
      Presets
    </Text>
    <Wrap spacing={2}>
      {PRESETS.map((p) => {
        const isActive = activePresetId === p.id;
        return (
          <WrapItem key={p.id}>
            <Button
              size="sm"
              variant={isActive ? 'solid' : 'outline'}
              colorScheme="teal"
              borderRadius="full"
              fontWeight="600"
              onClick={() => onSelect(p.id)}
              aria-pressed={isActive}
            >
              {p.label}
            </Button>
          </WrapItem>
        );
      })}
    </Wrap>
  </Flex>
);

export default PresetBar;
